<div
  class="outer"
>
  <h2>
    Activation
  </h2>

  <div
    class="instructions"
  >
    Follow the activation steps <i class="fa-regular fa-circle-1"></i><i class="fa-regular fa-circle-2"></i><i class="fa-regular fa-circle-3"></i> for each Motion Hub you wish to add to your account.
  </div>

  <div
    class="activation"
  >
    <div>
      <h3>
        <i class="fa-solid fa-circle-1"></i> Enter Hub ID
      </h3>

      <div
        class="hub-id"
      >
        <i class="fa-regular fa-square-h"></i>
        <input
          [(ngModel)]="hubId"
          (ngModelChange)="onHubIdChange()"
          type="tel"
          maxlength="7"
        >
      </div>
    </div>

    <div>
      <h3>
        <i class="fa-solid fa-circle-2"></i> Enter Activation Code
      </h3>
      <div
        class="activation-code"
      >
        <input
          [(ngModel)]="activationCode"
          (ngModelChange)="onActivationCodeChange()"
          placeholder="xxxx-xxxx-xxxx"
          maxlength="14"
        >
      </div>
    </div>

    <div>
      <h3>
        <i class="fa-solid fa-circle-3"></i> Activate
      </h3>

      <motn-save-revert-buttons
        #saveButton
        [status]="status"
        [small]="false"
        [color]="'green'"
        [enableRevert]="false"
        [saveButtonText]="'Submit Activation'"
        (updatedStatus$)="status = $event"
        (clickedSave$)="activate()"
      ></motn-save-revert-buttons>
    </div>
  </div>
</div>
